import { ACTIONS } from './constants';
import { sortList } from '@app/utils';

const reducer = (state, action) => {
  if (action.type === ACTIONS.SORT) {
    const {
      sortBy: newSortBy,
      type: newType,
      dir: newDir,
      data: newData,
      order: newOrder
    } = action.payload;
    return {
      ...state,
      sortBy: newSortBy,
      sortDirection: newDir,
      sortType: newType,
      listData: sortList({
        id: newSortBy,
        order: newOrder,
        dir: newDir,
        type: newType,
        data: newData
      })
    };
  }
  if (action.type === ACTIONS.INITIALIZE_SORT) {
    return {
      ...state,
      ...action.payload
    };
  }
  return state;
};

export default reducer;
